export const API_KEY = "a2007a3b48e7414a3fab9f6bdb9966ca";
export const LANG = "en-US";
export const REGION = "IN";

export const POSTER_PATH = "https://image.tmdb.org/t/p/w185";
export const BACKDROP_PATH = "https://image.tmdb.org/t/p/w1280";

export const POSTER_PLACEHOLDER = "http://via.placeholder.com/185x278";


// WEBPACK FOOTER //
// ./src/utils/const.js